/* Happy Yak storefront mockup: generic product page (gallery, variant picker, quantity).
   Loaded by sections/mockup-storefront-product-main.liquid. Does not touch the 3-pack page. */
(function () {
  document.querySelectorAll('[data-mp]').forEach(init);

  function formatMoney(cents, format) {
    var amount = (cents / 100);
    var fmt = format || '${{amount}}';
    function withCommas(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withCommas(amount.toFixed(2)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas(String(Math.round(amount))))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
  }

  function init(root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-mp-variants]').textContent); } catch (e) { data = { options: [], variants: [] }; }
    var variants = data.variants || [];
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    // ---------- gallery ----------
    var main = root.querySelector('[data-mp-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mp-thumb]'));
    function showMedia(btn) {
      if (!btn || !main) return;
      thumbs.forEach(function (t) { t.setAttribute('aria-selected', t === btn ? 'true' : 'false'); });
      if (main.getAttribute('src') !== btn.dataset.src) {
        main.src = btn.dataset.src;
        main.removeAttribute('srcset');
      }
      main.alt = btn.dataset.alt || '';
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { showMedia(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowRight' && e.key !== 'ArrowUp' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var visible = thumbs.filter(function (x) { return !x.hidden; });
        var idx = visible.indexOf(t);
        var next = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? visible[idx + 1] || visible[0] : visible[idx - 1] || visible[visible.length - 1];
        if (next) { next.focus(); showMedia(next); }
      });
    });
    // ---------- photo viewer (click the main photo; arrows / keys step; click again to zoom) ----------
    var zoom = root.querySelector('[data-mp-zoom]');
    var openZoomBtn = root.querySelector('[data-mp-open-zoom]');
    if (zoom && openZoomBtn) {
      var zoomImg = zoom.querySelector('[data-mp-zoom-img]');
      var zoomStage = zoom.querySelector('[data-mp-zoom-stage]');
      var zoomCount = zoom.querySelector('[data-mp-zoom-count]');
      var zoomIndex = 0, lastFocus = null;
      function zoomList() { return thumbs.filter(function (t) { return !t.hidden; }); }
      function zoomShow(i) {
        var list = zoomList();
        if (!list.length) return;
        zoomIndex = (i + list.length) % list.length;
        var t = list[zoomIndex];
        zoom.classList.remove('is-zoomed');
        zoomImg.style.transformOrigin = '50% 50%';
        zoomImg.src = t.dataset.large || t.dataset.src;
        zoomImg.alt = t.dataset.alt || '';
        if (zoomCount) zoomCount.textContent = (zoomIndex + 1) + ' / ' + list.length;
        showMedia(t);
      }
      function zoomOpen() {
        var list = zoomList();
        var current = list.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
        lastFocus = document.activeElement;
        zoom.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        zoomShow(current < 0 ? 0 : current);
        var close = zoom.querySelector('[data-mp-zoom-close]');
        if (close) close.focus();
      }
      function zoomClose() {
        zoom.hidden = true;
        zoom.classList.remove('is-zoomed');
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      openZoomBtn.addEventListener('click', zoomOpen);
      zoom.querySelector('[data-mp-zoom-close]').addEventListener('click', zoomClose);
      zoom.querySelectorAll('[data-mp-zoom-step]').forEach(function (b) {
        b.addEventListener('click', function () { zoomShow(zoomIndex + parseInt(b.dataset.mpZoomStep, 10)); });
      });
      zoomImg.addEventListener('click', function (e) {
        var r = zoomImg.getBoundingClientRect();
        zoomImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        zoom.classList.toggle('is-zoomed');
      });
      zoomStage.addEventListener('click', function (e) { if (e.target === zoomStage) zoomClose(); });
      document.addEventListener('keydown', function (e) {
        if (zoom.hidden) return;
        if (e.key === 'Escape') zoomClose();
        else if (e.key === 'ArrowRight') zoomShow(zoomIndex + 1);
        else if (e.key === 'ArrowLeft') zoomShow(zoomIndex - 1);
      });
      // Swipe on touch screens.
      var touchX = null;
      zoomStage.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      zoomStage.addEventListener('touchend', function (e) {
        if (touchX === null || zoom.classList.contains('is-zoomed')) return;
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 50) zoomShow(zoomIndex + (dx < 0 ? 1 : -1));
        touchX = null;
      });
    }

    var variantMediaIds = {};
    variants.forEach(function (v) { if (v.featured_media && v.featured_media.id) variantMediaIds[v.featured_media.id] = true; });
    var distinctVariantMedia = Object.keys(variantMediaIds).length;

    function syncGalleryToVariant(v) {
      var mediaId = v && v.featured_media ? String(v.featured_media.id) : null;
      // Hide photos that belong to other colourways (same behaviour as Dawn's "hide other variants' media").
      if (distinctVariantMedia > 1 && mediaId) {
        thumbs.forEach(function (t) {
          if (t.dataset.variantMedia === 'true') t.hidden = t.dataset.mediaId !== mediaId;
        });
      }
      if (mediaId) {
        var match = thumbs.filter(function (t) { return t.dataset.mediaId === mediaId; })[0];
        if (match) showMedia(match);
      }
    }

    // ---------- variant picker ----------
    var idInput = root.querySelector('[data-mp-id]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-mp-option]'));
    var priceEl = root.querySelector('[data-mp-price]');
    var compareEl = root.querySelector('[data-mp-compare]');
    var saveEl = root.querySelector('[data-mp-save]');
    var availEl = root.querySelector('[data-mp-avail]');
    var addBtn = root.querySelector('[data-mp-add]');
    var notifyEl = root.querySelector('[data-mp-notify]');

    function buttonsIn(group) { return Array.prototype.slice.call(group.querySelectorAll('[data-mp-value]')); }
    function selectedValues() {
      return groups.map(function (g) {
        var b = g.querySelector('[aria-checked="true"]');
        return b ? b.dataset.mpValue : null;
      });
    }
    function matches(v, values) {
      for (var i = 0; i < values.length; i++) {
        if (values[i] !== null && v.options[i] !== values[i]) return false;
      }
      return true;
    }
    function findExact(values) {
      for (var i = 0; i < variants.length; i++) if (matches(variants[i], values)) return variants[i];
      return null;
    }
    // When the exact combination doesn't exist, keep the value the shopper just picked and move the
    // other selectors to the closest real variant (available first, most shared values first).
    function findClosest(values, lockedIndex) {
      var best = null, bestScore = -1;
      variants.forEach(function (v) {
        if (v.options[lockedIndex] !== values[lockedIndex]) return;
        var score = 0;
        values.forEach(function (val, i) { if (i !== lockedIndex && v.options[i] === val) score += 2; });
        if (v.available) score += 1;
        if (score > bestScore) { bestScore = score; best = v; }
      });
      return best;
    }
    function setChecked(groupIndex, value) {
      var group = groups[groupIndex];
      var label = group.querySelector('[data-mp-selected]');
      buttonsIn(group).forEach(function (b) { b.setAttribute('aria-checked', b.dataset.mpValue === value ? 'true' : 'false'); });
      if (label) label.textContent = value;
    }
    function refreshStates() {
      var values = selectedValues();
      groups.forEach(function (g, gi) {
        buttonsIn(g).forEach(function (b) {
          var candidate = values.slice();
          candidate[gi] = b.dataset.mpValue;
          var exists = false, available = false;
          for (var i = 0; i < variants.length; i++) {
            if (matches(variants[i], candidate)) { exists = true; if (variants[i].available) { available = true; break; } }
          }
          b.disabled = !exists;
          b.classList.toggle('is-soldout', exists && !available);
          b.title = !exists ? 'Not offered in this combination' : (!available ? 'Sold out' : '');
        });
      });
    }
    function render(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = formatMoney(v.compare_at_price, moneyFormat); }
      if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = 'Save ' + formatMoney(v.compare_at_price - v.price, moneyFormat); }
      if (availEl) {
        availEl.dataset.state = v.available ? 'in' : 'out';
        availEl.textContent = v.available ? 'In stock, ships from the U.S.' : 'Sold out';
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.innerHTML = v.available ? 'Add to cart · <span data-mp-btn-price>' + formatMoney(v.price, moneyFormat) + '</span>' : 'Sold out';
      }
      if (notifyEl) notifyEl.hidden = v.available;
      syncGalleryToVariant(v);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
      root.dispatchEvent(new CustomEvent('mp:variant', { detail: v }));
    }
    function choose(groupIndex, value) {
      setChecked(groupIndex, value);
      var values = selectedValues();
      var v = findExact(values) || findClosest(values, groupIndex);
      if (v) v.options.forEach(function (val, i) { if (groups[i]) setChecked(i, val); });
      refreshStates();
      render(v);
    }

    groups.forEach(function (g, gi) {
      buttonsIn(g).forEach(function (b) {
        b.addEventListener('click', function () { if (!b.disabled) choose(gi, b.dataset.mpValue); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
          e.preventDefault();
          var list = buttonsIn(g).filter(function (x) { return !x.disabled; });
          var idx = list.indexOf(b);
          var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? list[idx + 1] || list[0] : list[idx - 1] || list[list.length - 1];
          if (next) { next.focus(); choose(gi, next.dataset.mpValue); }
        });
      });
    });

    // Initial state: honour ?variant= in the URL, else the server-rendered selection.
    var initial = null;
    try {
      var qv = new URL(window.location.href).searchParams.get('variant');
      if (qv) initial = variants.filter(function (v) { return String(v.id) === qv; })[0] || null;
    } catch (e) { /* ignore */ }
    if (!initial && idInput) initial = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || null;
    if (!initial) initial = variants.filter(function (v) { return v.available; })[0] || variants[0] || null;
    if (initial) {
      initial.options.forEach(function (val, i) { if (groups[i]) setChecked(i, val); });
      refreshStates();
      render(initial);
    }

    // ---------- quantity stepper ----------
    var qtyInput = root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-mp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = parseInt(qtyInput.value, 10) || 1;
        n = Math.min(99, Math.max(1, n + parseInt(b.dataset.mpQty, 10)));
        qtyInput.value = n;
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      var n = parseInt(qtyInput.value, 10);
      if (!n || n < 1) qtyInput.value = 1;
    });
  }
})();
